import axios from 'axios';
import url from '../url.js';

const tokenService = {
  /**
   * 更新 JWT token
   * @returns {Promise<boolean>} 是否成功更新
   */
  async renewToken() {
    try {
      const jwtToken = localStorage.getItem('jwtToken');
      if (!jwtToken) {
        console.warn('No JWT token found');
        return false;
      }

      const headers = { Authorization: `Bearer ${jwtToken}` };
      const renewResponse = await axios.get(`${url.backendHost}api/users/renew`, { 
        headers, 
        withCredentials: true 
      });
      
      const newToken = renewResponse.data.jwtToken;
      if (newToken) {
        localStorage.setItem('jwtToken', newToken);
        console.log('Token 已更新');
        return true;
      }
      
      return false;
    } catch (error) {
      console.warn('Token renewal failed:', error);
      return false;
    }
  }
};

export default tokenService;
